import { render } from "./RenameModal.vue?vue&type=template&id=7cfe70a6&scoped=true"
import script from "./RenameModal.vue?vue&type=script&lang=js"
export * from "./RenameModal.vue?vue&type=script&lang=js"

import "./RenameModal.vue?vue&type=style&index=0&id=7cfe70a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cfe70a6"]])

export default __exports__